<script lang="ts">
	import { tokensAllowedForDeposit } from '$lib/home/scwallet/config';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import { addDollarSign, getNumBackInUnits } from '$lib/util/util';
	import {
		aggregatedSwapMarginPossible,
		liquidityProviderForSwap,
		loadingMatchaCallData,
		matchaCallData
	} from '$lib/home/store';

	let expandRateOfSwap: boolean = false;
</script>

<!-- Rate of Swap -->
<button
	class="flex w-full justify-between cursor-pointer"
	on:click={() => (expandRateOfSwap = !expandRateOfSwap)}
	on:keydown={() => (expandRateOfSwap = !expandRateOfSwap)}
>
	<div class="text-fx-grey-400 text-xs cursor-help">
		<Tooltip header="Rate of Swap" title="Details to swap non-sUSD assets to sUSD assets"
			>Rate Of Swap</Tooltip
		>
	</div>
	<div class="text-fx-grey-300 text-xs font-medium flex gap-1">
		{#if $loadingMatchaCallData}
			<ProcessingIcon />
		{/if}

		{#if $matchaCallData && Object.keys($matchaCallData).length !== 0}
			<img
				loading="lazy"
				src={'/down-arrow.png'}
				class="h-1.5 mt-1 transition duration-300 {expandRateOfSwap ? 'rotate-180' : ''}"
				alt=""
			/>
		{:else if !$loadingMatchaCallData}
			-
		{/if}
	</div>
</button>

<!-- Rate of Swap Drop Down -->
{#if $matchaCallData && Object.keys($matchaCallData).length !== 0 && expandRateOfSwap}
	<div class="flex w-full justify-between">
		<div class="text-fx-grey-400 text-xs cursor-pointer">Amount sUSD after swap</div>
		<div class="text-fx-grey-300 text-xs font-medium">
			{addDollarSign(getNumBackInUnits($aggregatedSwapMarginPossible.toString(), 18, 2))}
		</div>
	</div>
	{#each $tokensAllowedForDeposit as token}
		{#if token != 'sUSD' && $matchaCallData[token]}
			<div class="flex justify-between text-xs">
				<div class="flex gap-1 text-fx-grey-400 flex-col">
					<div class="font-semibold">{token}</div>
					<div class="flex justify-between gap-1 text-xxs">
						(
						<div class="flex gap-1">
							<div>1</div>
							<div>
								<div>sUSD</div>
							</div>
						</div>
						<div>=</div>
						<div class="flex gap-1">
							<div class="flex flex-col">
								{#if $matchaCallData[token]}
									{getNumBackInUnits($matchaCallData[token].grossPrice, 0, 5)}
								{/if}
							</div>
							<div class="flex gap-1">
								<div>{token}</div>
							</div>
						</div>
						)
					</div>
				</div>
				<div class="flex flex-col">
					{#if $liquidityProviderForSwap[token]}
						{#each $liquidityProviderForSwap[token] as matchaTokenInfo}
							<div class="flex gap-1 text-fx-grey-400">
								<div>
									{addDollarSign(
										getNumBackInUnits($matchaCallData[token].buyAmount.toString(), 18, 2)
									)}
								</div>
								<div class="flex flex-col">
									{#if matchaTokenInfo.name === 'MultiHop' && matchaTokenInfo.hops}
										<div class="text-fx-grey-400 underline cursor-pointer text-center">Hops</div>
										{#each matchaTokenInfo.hops as hop}
											<div class="text-center">{hop}</div>
										{/each}
									{:else}
										<div class="text-center">{matchaTokenInfo.name}</div>
									{/if}
								</div>
							</div>
						{/each}
					{/if}
				</div>
			</div>
		{/if}
	{/each}
{/if}
